import React, { useEffect, useState } from "react";
import { PiSuitcaseSimple } from "react-icons/pi";
import { IoIosArrowDropright } from "react-icons/io";
import { AiOutlineCheckCircle, AiOutlineCrown } from "react-icons/ai";
import office from "../../assests/office-building.png";
import { GoClock } from "react-icons/go";
import { IoLocationOutline, IoPersonOutline } from "react-icons/io5";
import { LuDot } from "react-icons/lu";

const JobCard = ({
  logo,
  title,
  company,
  postedTime,
  salaryRange,
  experience,
  jobType,
  onApply,
  onApplyMobile,
  hasApplied,
  index,
  featured,
  JobInternship,
  job,
  isOpen,
  location,
  skills,
}) => {
  const formatDate = () => {
    const date = new Date(postedTime);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    return `${day} ${month}`;
  };
  const [isHoveredIndex, setIsHoveredIndex] = useState(null);

  function formatLocation(location, number = 30) {
    // Check if the location length exceeds 30 characters
    if (location.length > number) {
      // Return the first number characters followed by ellipses
      return location.substring(0, number) + "...";
    }
    // Return the original location if it's 30 characters or less
    return location;
  }

  // useEffect(() => {
  //   console.log(skills, "skills");
  // }, [skills]);

  return (
    <>
      {/* Desktop view */}
      <div
        className="rounded-xl shadow-lg hover:shadow-none relative cursor-pointer w-full bg-white border border-transparent hover:border-primary p-4 md:p-6 transition duration-300 ease-in-out transform hover:scale-[1.02] block"
        onMouseEnter={() => setIsHoveredIndex(index)}
        onMouseLeave={() => setIsHoveredIndex(null)}
        onClick={onApply}
      >
        <div className="flex items-start justify-between gap-6">
          <div className="flex-grow">
            <div className="flex items-start justify-between mb-2">
              <h3 className="text-lg font-semibold text-gray-900">
                {formatLocation(title, 30)}
              </h3>
            </div>

            <div className="flex items-center gap-2 text-gray-600 md:text-sm text-xs mb-4">
              <span>{company}</span>
            </div>
            {/* {JobInternship && job.technicalInterview && (
              <div className="flex flex-wrap gap-4 mb-4">
                <div className="flex items-center gap-1 text-sm text-gray-700">
                  <AiOutlineCheckCircle className="text-primary text-lg" />
                  <span>Technical</span>
                </div>
                {job.hrInterview && (
                  <div className="flex items-center gap-1 text-sm text-gray-700">
                    <AiOutlineCheckCircle className="text-primary text-lg" />
                    <span>HR</span>
                  </div>
                )}
                {job.mockTest && (
                  <div className="flex items-center gap-1 text-sm text-gray-700">
                    <AiOutlineCheckCircle className="text-primary text-lg" />
                    <span>MCQ</span>
                  </div>
                )}
              </div>
            )} */}
          </div>

          <div className="flex-shrink-0">
            <img
              src={logo}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = office;
              }}
              alt={`${company} Logo`}
              className="w-14 h-14 object-cover rounded-lg"
            />
          </div>
        </div>

        <div className="flex flex-wrap items-center md:gap-4 gap-2 mb-1 text-sm text-gray-600">
          <div className="flex items-center md:gap-2 gap-1">
            <PiSuitcaseSimple />
            <span>{experience} years</span>
          </div>
          <div className="flex items-center md:gap-2 gap-1 border-l-2 border-gray-300 md:pl-3 pl-2">
            <span>{salaryRange}</span>
          </div>
          <div className="flex items-center md:gap-2 gap-1  border-l-2 border-gray-300 md:pl-3 pl-2">
            <IoLocationOutline />
            <span>{location}</span>
          </div>
        </div>

        <div className="flex flex-wrap gap-2 my-2">
          {skills && skills.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {skills.slice(0, 3).map((skill, index) => (
                <span
                  key={index}
                  className="px-3 py-1 text-xs bg-gray-100 text-gray-700 rounded-full"
                >
                  {skill}
                </span>
              ))}
              {skills.length > 3 && (
                <span className="px-3 py-1 text-xs bg-gray-100 text-gray-700 rounded-full">
                  +{skills.length - 3}
                </span>
              )}
            </div>
          )}
        </div>

        <div className="flex justify-between items-center">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onApply();
            }}
            className={`${
              hasApplied ? "text-green-500" : "text-primary"
            } flex items-center gap-2 text-sm font-medium hover:underline`}
          >
            {hasApplied ? (
              <>
                Applied
                <AiOutlineCheckCircle className="text-lg" />
              </>
            ) : (
              <>
                Apply now
                <IoIosArrowDropright className="text-lg" />
              </>
            )}
          </button>

          <div className="flex items-center gap-1 text-xs text-gray-500">
            <GoClock />
            <span>{formatDate()}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobCard;
